export default __webpack_public_path__ + "static/coctail-01-d077f6aa6efa4a7b6ae5ff8b9ddeef46.png";